import { Map as iMap } from 'immutable';
const initialState = iMap();

export function signin(state = initialState, action) {
  switch (action.type) {
    case 'CONFIRM_SIGNIN_EMAIL_SUCCESS':
      if (action.payload.error) return state.set('signinError', action.payload.message);
      return state.set('signinInfo', action.payload.message);
    case 'CONFIRM_SECONDARY_EMAIL':
    case 'CONFIRM_DISASSOCIATE_SECONDARY':
      if (action.payload.error) return state.set('signinError', action.payload.message);
      return state;
    case 'UPDATE_INFO_BOX':
      return state.merge(iMap({ signinInfo: action.messages.signinInfo, signinError: action.messages.signinError }));
    case 'CLEAR_INFO_BOX_MESSAGE':
      return state.merge(iMap({ signinInfo: undefined, signinError: undefined }));
    case 'CLEAR_STORES':
    case 'AUTH_RECEIVED':
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/sign-in/sign-in-reducer.js